import { Routes, Route, Navigate } from "react-router-dom";
import ForgotPassword from "@shared/hoc/auth/ForgotPassword";
import Login from "@shared/hoc/auth/Login";
import SignUp from "@shared/hoc/auth/Signup";

const AuthRoutes = () => {
  return (
    <Routes>
      <Route path="login" element={<Login />} />
      <Route path="signup" element={<SignUp />} />
      <Route path="forgot/:id" element={<ForgotPassword />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};

export default AuthRoutes;
